import { createRouter, createWebHistory } from 'vue-router'
import LandingPage from '../components/LandingPage.vue'
import RegisterUser from '../components/login/RegisterUser.vue'
import LoginUser from '../components/login/LoginUser.vue'
import UserDetails from '../components/UserDetails.vue'
import TravelConsultation from '../components/TravelConsultation.vue';
import VisaFacilitation from '../components/VisaFacilitation.vue'
import AboutPage from '../components/AboutPage.vue'
import ForgotPassword from '../components/login/ForgotPassword'

// Define your routes
const routes = [
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage
  },
  {
    path: '/register',
    name: 'RegisterUser',
    component: RegisterUser
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage
  },
  {
    path:'/visa-facilitation',
    name: 'VisaFacilitation',
    component: VisaFacilitation

  },
  {
    path: '/login',
    name: 'LoginUser',
    component: LoginUser
  },
  {
    path: '/user-details',
    name: 'UserDetails',
    component: UserDetails
  },
  {
    path: '/travel-consultation',
    name: 'TravelConsultation',
    component: TravelConsultation
  }
]

// Create the router instance and configure it
const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
